import { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'dva';
import ArchiveIcon from '@material-ui/icons/Archive';
import { useIntl } from 'umi';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import ErrorIcon from '@material-ui/icons/Error';
import webStorage from '@/utils/storageManager';
import Fab from '@material-ui/core/Fab';
import ModalML from '@/components/ModalML';
import DataTableNativeML from '@/components/DataTableNativeML';
import { fmtThousand } from '@/utils/comUtil';
import ConsumptionRecordDetail from '@/pages/cm/mm/ml/containers/detail_components/CodeDetail';
import { COUPON_STATUS } from '@/constants';
import ResultListStyled from './ResultListStyled';

const ResultList = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const COUPON_SOURCE_TYPE = webStorage.get('DICTOBJ')?.COUPON_SOURCE_TYPE;
  const loadingEffect = useSelector((state) => state.loading);
  const couponUseListLoading =
    loadingEffect.effects[
      ('cpDataList/getCpDataList', 'cpDataList/getCpDataListNum')
    ];
  const dispatch = useDispatch();
  //查询参数
  const { searchParam, setSearchParam } = props;
  const downloadRef = useRef();
  //改变页码
  const changePage = (obj) => {
    setSearchParam({ ...searchParam, ...obj });
  };

  //列表数据
  const {
    data: cpDataList,
    total,
    hasNext,
  } = useSelector((state) => state.cpDataList?.cpDataList) || {};
  //列表数据
  const { allTotal } = useSelector((state) => state.cpDataList) || {};
  const [alertOpen, setAlertOpen] = useState(false);
  //获取数据接口
  const fetchCpDataList = useCallback(() => {
    let companies = searchParam.companies;
    let stores = searchParam.stores;
    if (!companies) {
      companies = null;
    }
    if (!stores) {
      stores = null;
    }

    dispatch({
      type: 'cpDataList/getCpDataList',
      payload: {
        values: {
          ...searchParam,
          companies,
          stores,
          searchCount: false,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    searchParam.couponId,
    searchParam.refreshTime,
    searchParam.consumeEndTime,
    searchParam.consumeStartTime,
    searchParam.couponType,
    searchParam.status,
    searchParam.level,
    searchParam.companies,
    searchParam.stores,
    searchParam.thirdId,
    searchParam.source,
    searchParam.sendStartTime,
    searchParam.sendEmdTime,
    searchParam.mobile,
    searchParam.pageNum,
    searchParam.pageSize,
  ]);

  const fetchCpDataListNum = useCallback(() => {
    let companies = searchParam.companies;
    let stores = searchParam.stores;
    if (!companies) {
      companies = null;
    }
    if (!stores) {
      stores = null;
    }

    dispatch({
      type: 'cpDataList/getCpDataListNum',
      payload: {
        values: {
          ...searchParam,
          companies,
          stores,
          searchCount: true,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    searchParam.couponId,
    searchParam.refreshTime,
    searchParam.consumeEndTime,
    searchParam.consumeStartTime,
    searchParam.couponType,
    searchParam.status,
    searchParam.level,
    searchParam.companies,
    searchParam.stores,
    searchParam.thirdId,
    searchParam.source,
    searchParam.sendStartTime,
    searchParam.sendEmdTime,
    searchParam.mobile,
    searchParam.pageNum,
    searchParam.pageSize,
  ]);

  useEffect(() => {
    fetchCpDataList();
  }, [fetchCpDataList]);
  useEffect(() => {
    fetchCpDataListNum();
  }, [fetchCpDataListNum]);
  //导出
  const handleClickExport = () => {
    let companies = searchParam.companies;
    let stores = searchParam.stores;
    if (!companies) {
      companies = null;
    }
    if (!stores) {
      stores = null;
    }
    window.NE_DAWN.trigger(downloadRef.current, {
      event: '_ec', // 事件名
      params: { ...searchParam, companies, stores }, // 事件公参
    });
    dispatch({
      type: 'cpDataList/downloadDataPage',
      payload: {
        values: {
          ...searchParam,
          companies,
          stores,
        },
      },
      callback: (code) => {
        if (code === 0) {
          setAlertOpen(true);
        }
      },
    });
    // if (allTotal > 10000) {
    //   window.message.toast({
    //     type: 'error',
    //     message: '下载数据量过大，请缩小查询条件的范围',
    //     title: '失败',
    //   });
    // } else {
    //   let companies = searchParam.companies;
    //   let stores = searchParam.stores;
    //   if (!companies) {
    //     companies = null;
    //   }
    //   if (!stores) {
    //     stores = null;
    //   }
    //   download('/coupon/downloadDataPage', {
    //     ...searchParam,
    //     companies,
    //     stores,
    //   });
    // }
  };
  const handleClose = () => {
    setAlertOpen(false);
  };
  //打开订单弹窗
  const [open, setOpen] = useState(false);
  const handleCancel = () => {
    setOpen(false);
  };
  const { orderData } = useSelector((state) => state.cpDataList) || {};
  const handleOrderDetail = (orderNo) => {
    if (orderNo) {
      dispatch({
        type: 'cpDataList/getOrderId',
        payload: {
          values: {
            orderNo,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            setOpen(true);
          }
          console.log(res);
        },
      });
    }
  };

  const columns = [
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl01' }),
      align: 'center',
      id: 'ownerName',
      event: {},
    },
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl02' }),
      align: 'center',
      id: 'memberCode',
      key: 'memberCode',
      width: 200,
    },
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl03' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 200,
    },
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl04' }),
      align: 'center',
      id: 'couponId',
      key: 'couponId',
      width: 200,
    },
    {
      align: 'center',
      title: formatMessage({ id: 'coupon.data.c01.lbl05' }),
      id: 'couponName',
      event: {},
      width: '200',
    },
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl06' }),
      align: 'center',
      id: 'cardCode',
      key: 'cardCode',
      width: 200,
    },
    {
      align: 'center',
      title: formatMessage({ id: 'coupon.data.c01.lbl07' }),
      id: 'sourceType',
      event: {
        // onClick: (value, row) => handleMemberDetail(row),
      },
      width: '200',
      render: ({ sourceType }) => {
        return COUPON_SOURCE_TYPE.find((i) => i.nameEn === sourceType)?.nameZh;
      },
    },

    {
      title: formatMessage({ id: 'coupon.data.c01.lbl08' }),
      align: 'center',
      id: 'createDate',
      key: 'createDate',
      width: 200,
    },
    {
      title: '发放门店	',
      align: 'center',
      id: 'sendStoreName',
      key: 'sendStoreName',
      width: 200,
    },
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl09' }),
      align: 'center',
      id: 'couponStatus',
      key: 'couponStatus',
      width: 200,
      render: ({ status }) => {
        return COUPON_STATUS.find((i) => i.value === status)?.name;
      },
    },

    {
      title: formatMessage({ id: 'coupon.data.c01.lbl10' }),
      align: 'center',
      id: 'consumeTime',
      key: 'consumeTime',
      width: 200,
    },
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl11' }),
      align: 'center',
      id: 'orderNo',
      key: 'orderNo',
      width: 200,
      event: {
        onClick: (value, row) => handleOrderDetail(row.orderNo),
      },
      tdCellStyle: {
        color: 'rgb(21,101,192)',
        cursor: 'pointer',
      },
      render: ({ orderNo }) => {
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        return <div>{orderNo}</div>;
      },
    },
    {
      title: '订单金额',
      align: 'center',
      id: 'amountPaid',
      key: 'amountPaid',
      width: 200,
      render: (row) => (row.amountPaid ? fmtThousand(row.amountPaid) : 0),
    },
    {
      title: formatMessage({ id: 'coupon.data.c01.lbl12' }),
      align: 'center',
      id: 'consumeStoreName',
      key: 'consumeStoreName',
      width: 200,
    },

    {
      title: formatMessage({ id: 'coupon.data.c01.lbl13' }),
      align: 'center',
      id: 'couponUseChannel',
      key: 'couponUseChannel',
      render: ({ couponUseChannel }) => {
        switch (couponUseChannel) {
          case 'WEBSITE':
            return '爱步官网';
          case 'MINIPROGRAM':
            return '爱步官网小程序';
          case 'OFFLINE':
            return '线下渠道';
          default:
            return;
        }
      },
    },
  ];
  const headerTip = (
    <div className="number-wrapper">
      <div className="number">
        <span className="text">
          {formatMessage({ id: 'coupon.data.n02.lbl02' })}{' '}
        </span>
        <span> {fmtThousand(allTotal, 0)}</span>
        {/* <span className="text">订单金额总额</span>
        <span> {fmtThousand(amountPaid, 0)}</span> */}
      </div>
    </div>
  );
  return (
    <ResultListStyled>
      <div className="export-wrapper">
        <Fab
          data-log={JSON.stringify({
            oid: 'btn_coupon_center_coupon_data_details_download',
            events: ['_ev'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          ref={downloadRef}
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={handleClickExport}
        >
          <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
          {formatMessage({ id: 'coupon.data.n02.btn01' })}
        </Fab>
      </div>
      <div className="table-wrapper">
        <DataTableNativeML
          headerTip={headerTip}
          loading={couponUseListLoading}
          columns={columns}
          changePage={changePage}
          page={searchParam}
          paging={true}
          data={cpDataList}
          hasNext={hasNext}
          initP={true}
          total={total}
          columnKey="id"
        ></DataTableNativeML>
      </div>
      <ModalML
        open={open}
        onClose={handleCancel}
        title={formatMessage({ id: 'cm.member.detail.d03.lbl01' })}
        isHasBcg={false}
      >
        <ConsumptionRecordDetail
          detail={{ ...orderData, orderItemList: orderData?.orderItems }}
        />
      </ModalML>
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          优惠券数据下载中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </ResultListStyled>
  );
};
export default ResultList;
